/** Small unread-count chip shown next to a tab label (popover + drawer). */
export function CountChip({ count }: { count: number }) {
    if (count <= 0) return null;
    return (
        <span className="ml-1.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-muted px-1 text-[10px] font-medium leading-none text-muted-foreground">
            {count > 99 ? '99+' : count}
        </span>
    );
}
